import { factory, am } from './utils';

import httpClient from '@/utils/httpClient';
const GET_DIR_INDEX = am(`GET_DIR_INDEX`);
const RE_INDEX = am(`RE_INDEX`);
const FETCH_CURRENT_INVENTION_TREE = am(`FETCH_CURRENT_INVENTION_TREE`);

export default {
  namespaced: true,
  ...factory({
    state: {
      loading: false,
      index: {},
      failed: false,
      currentInventionTree: null
    },
    getters: {
      root: state => reference => {
        return state.index[reference]?.path;
      }
    },
    mutations: {
      [GET_DIR_INDEX.STARTED](state) {
        state.loading = true;
        state.failed = false;
      },
      [GET_DIR_INDEX.COMPLETED](state, index) {
        const indexMap = index.reduce((acc, curr) => {
          acc[curr.reference] = curr;
          return acc;
        }, {});

        state.index = indexMap;
        state.loading = false;
        state.failed = false;
      },
      [GET_DIR_INDEX.FAILED](state) {
        state.index = {};
        state.loading = false;
        state.failed = true;
      },
      [RE_INDEX.STARTED](state) {
        state.loading = true;
        state.failed = false;
      },
      [RE_INDEX.COMPLETED](state, { reference, path }) {
        state.index[reference] = { reference, path };
        state.loading = false;
        state.failed = false;
      },
      [RE_INDEX.FAILED](state) {
        state.loading = false;
        state.failed = true;
      },
      [FETCH_CURRENT_INVENTION_TREE.STARTED](state) {
        state.currentInventionTree = null;
        state.loading = true;
        state.failed = false;
      },
      [FETCH_CURRENT_INVENTION_TREE.COMPLETED](state, tree) {
        state.currentInventionTree = tree;
        state.loading = false;
        state.failed = false;
      },
      [FETCH_CURRENT_INVENTION_TREE.FAILED](state) {
        state.currentInventionTree = null;
        state.loading = false;
        state.failed = true;
      }
    },
    actions: {
      async initialize({ commit }) {
        try {
          commit(GET_DIR_INDEX.STARTED);
          const index = await httpClient.get(`/api/documents-repository-connector/index`);
          commit(GET_DIR_INDEX.COMPLETED, index);
        } catch {
          commit(GET_DIR_INDEX.FAILED);
        }
      },
      async getTree({ commit }, reference) {
        if (!reference) {
          return null;
        }
        commit(FETCH_CURRENT_INVENTION_TREE.STARTED);

        try {
          const response = await httpClient.get(`/api/documents-repository-connector/index/${reference}`);
          commit(FETCH_CURRENT_INVENTION_TREE.COMPLETED, response);
          return response;
        } catch (error) {
          commit(FETCH_CURRENT_INVENTION_TREE.FAILED);
          return null;
        }
      },
      async sync({ commit }, reference) {
        try {
          commit(RE_INDEX.STARTED);
          const token = await httpClient.post(`/api/documents-repository-connector/sync/enqueue/${reference}`);
          if (!token) {
            commit(RE_INDEX.FAILED);
            return;
          }

          let retry = 10;

          while (retry > 0) {
            try {
              await new Promise(resolve => setTimeout(resolve, 1000));
              const response = await httpClient.get(`/api/documents-repository-connector/sync/token/${token.id}`);
              if (response?.fullfiled) {
                if (response.status === 'succeeded') {
                  commit(RE_INDEX.COMPLETED, { reference, path: response.root });
                } else {
                  commit(RE_INDEX.FAILED);
                }
                return response;
              }
            } catch (error) {
              // swallow
            } finally {
              retry--;
            }
          }
          commit(RE_INDEX.FAILED);
          return null;
        } catch (e) {
          commit(RE_INDEX.FAILED);
          throw e;
        }
      }
    }
  })('directoryIndex', {
    async getCollection() {
      throw new Error('Not implemented.');
    },
    async getById() {
      throw new Error('Not implemented.');
    },
    async delete() {
      throw new Error('Not implemented.');
    },
    async update() {
      throw new Error('Not implemented.');
    }
  })
};
